import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { CompareMetric, CreatorCompare } from '../contract';
import {
  NO_COMPARE_TEXT,
  compareText,
  currColumnTitle,
  fmtHours,
  fmtKc,
  fmtNum,
  secondsToHours,
} from '../format';
import { PctBadge } from './metric-row';
import styles from '../style.module.scss';
import more from '../style-more.module.scss';

export const COMPARE_ROWS: { key: CompareMetric; label: string; fmt: (v: number) => string }[] = [
  { key: 'diamonds', label: 'Kim cương', fmt: (v) => fmtKc(v) },
  { key: 'liveSeconds', label: 'Giờ LIVE', fmt: (v) => fmtHours(secondsToHours(v)) },
  { key: 'liveDays', label: 'Ngày hợp lệ', fmt: (v) => fmtNum(v) },
  { key: 'newFollowers', label: 'Follower mới', fmt: (v) => fmtNum(v) },
  { key: 'liveSessions', label: 'Phiên LIVE', fmt: (v) => fmtNum(v) },
];

interface Row {
  key: CompareMetric;
  label: string;
  curr: string;
  prev: string;
  pct: number | null;
}

interface Props {
  compare: CreatorCompare | null | undefined;
  /** `facts.compareNote` — vì sao chưa so được (hiện khi `compare` = null). */
  note?: string | null;
}

/** Drawer: "So với tháng trước" — 5 chỉ số với nhãn nguồn (đặc tả 04 D3). */
const CompareBlock = ({ compare, note }: Props) => {
  if (!compare) {
    return (
      <section className={styles.card} aria-label="So với tháng trước">
        <h2 className={styles.cardTitle}>So với tháng trước</h2>
        <p className={styles.muted}>{note || NO_COMPARE_TEXT}.</p>
      </section>
    );
  }
  const rows: Row[] = COMPARE_ROWS.map(({ key, label, fmt }) => {
    const v = compare.metrics[key] || { curr: null, prev: null, pct: null };
    return {
      key,
      label,
      curr: v.curr === null ? '—' : fmt(v.curr),
      prev: v.prev === null ? '—' : fmt(v.prev),
      pct: v.pct,
    };
  });
  const columns: ColumnsType<Row> = [
    { title: 'Chỉ số', dataIndex: 'label' },
    { title: currColumnTitle(compare.mode, compare.label), dataIndex: 'curr', align: 'right' },
    { title: 'Tháng trước', dataIndex: 'prev', align: 'right' },
    { title: 'Thay đổi', dataIndex: 'pct', render: (v: number | null) => <PctBadge pct={v} /> },
  ];
  const source = compareText(compare.mode, compare.label, compare.n);
  return (
    <section className={styles.card} aria-label="So với tháng trước">
      <h2 className={styles.cardTitle}>So với tháng trước</h2>
      <p className={more.note}>Nguồn: {source}.</p>
      <Table<Row>
        size="small"
        rowKey="key"
        columns={columns}
        dataSource={rows}
        pagination={false}
        scroll={{ x: 420 }}
      />
    </section>
  );
};

export default CompareBlock;
